export { getLayoutForEntity } from './AdManagerPageLayout';
